(() => {
  if (!customElements.get('product-price-varies')) {
    customElements.define(
      'product-price-varies',
      class ProductPriceVaries extends HTMLElement {
        constructor() {
          super();

          this.product = window.productData;
          this.initialVariant = window.productData.initialVariant;
          this.els();
          this.init();
        };

        els() {
          this.messageWrapper = document.querySelector('[data-product-prices-vary]');
          /* this.message = this.messageWrapper.querySelector('[data-product-prices-vary-discount]') */
        }

        init() {
          /*
          document.addEventListener('DOMContentLoaded', () => {
            this.updateMessage(this.initialVariant);
          });
          */

          this.updateMessage(this.initialVariant);

          document.addEventListener('variantChange', (e) => {
            if (e.detail.variant) {
              this.updateMessage(e.detail.variant);
            }
          });
        };

        hideMessage() {
          this.messageWrapper.classList.add('hidden');
        };

        showMessage() {
          this.messageWrapper.classList.remove('hidden');
        };

        updateMessage(variant) {
          this.hideMessage();

          if (!this.messageWrapper) {
            return;
          }

          if (!this.product.price_varies) {
            return;
          }

          /*
          let variantPrices = this.product.variants.filter(variant => variant.available).map(variant => variant.price);
          let maxVariantPrice = Math.max(...variantPrices);
          let minVariantPrice = Math.min(...variantPrices);

          if(maxVariantPrice === minVariantPrice) {
            return;
          }

          if (variant.price === minVariantPrice) {
            return;
          }

          let discount = Math.floor(Math.abs(100 * ((minVariantPrice - maxVariantPrice) / maxVariantPrice)));
          this.message.textContent = discount;
          */

          this.showMessage();
        };
      }
    )
  }
})();